import { render, staticRenderFns } from "./Detalhe_Cupom.vue?vue&type=template&id=e42c5c66&scoped=true&"
import script from "./Detalhe_Cupom.vue?vue&type=script&lang=js&"
export * from "./Detalhe_Cupom.vue?vue&type=script&lang=js&"
import style0 from "./Detalhe_Cupom.vue?vue&type=style&index=0&id=e42c5c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42c5c66",
  null
  
)

export default component.exports